import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { legend } from "./legend.module.scss";

const Legend = ({ className, ...props }) => (
  <div className={classNames(legend, className)} {...props} />
);

Legend.propTypes = {
  className: PropTypes.string
};

Legend.defaultProps = {
  className: ""
};

export default Legend;
